import { render, staticRenderFns } from "./ISTExport.vue?vue&type=template&id=2a83a831&scoped=true&"
import script from "./ISTExport.vue?vue&type=script&lang=js&"
export * from "./ISTExport.vue?vue&type=script&lang=js&"
import style0 from "./ISTExport.vue?vue&type=style&index=0&id=2a83a831&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83a831",
  null
  
)

export default component.exports